<template>
	<div>
		<div class="d-block mb-4">
			<label class="label">
				Promotion
			</label>
			<CButton
				type="button"
				class="btn btn-add float-right"
				color="secondary"
				data-test-id="button-add"
				@click="$refs['modal-promotion'].open()"
			>
				{{ `${hasListItem ? 'Edit' : 'Add'} promotion` }}
			</CButton>
		</div>
		<div class="promotion-box" :class="{ 'is-invalid': !isValid }">
			<BaseNoItemBanner
				v-if="!hasListItem"
				text="There are no promotion for this rule"
			/>
			<template v-else>
				<header class="d-flex mb-1 promotion-box-list">
					<span
						v-for="head in promotionsTableFields"
						:key="head.key"
						:class="[
							'label',
							head.class ? `promotion-box-${head.key}` : '',
						]"
					>
						{{ head.label }}
					</span>
				</header>
				<ul class="list-unstyled border rounded-sm border-secondary px-3 py-3">
					<li
						v-for="(item, index) in list"
						:key="index"
						class="d-flex promotion-box-data"
					>
						<div
							v-for="data in promotionsTableFields"
							:key="data.key"
							:class="[data.class ? `promotion-box-${data.key}` : '']"
						>
							<template v-if="data.key === 'title'">
								{{ item[data.key].name }}
							</template>
							<template v-else-if="data.key === 'type'">
								<div class="name">
									{{ item[data.key].name }}
								</div>
								<div class="caption">
									{{ item[data.key].reward }}
								</div>
							</template>
							<template v-else>
								{{ item[data.key] }}
							</template>
						</div>
					</li>
				</ul>
			</template>
		</div>
		<div v-if="invalidFeedback" class="invalid-feedback">
			{{ invalidFeedback }}
		</div>
		<ModalPromotion
			ref="modal-promotion"
			:list="list"
			data-test-id="modal-promotion"
			@onConfirm="handleListChange"
		/>
	</div>
</template>

<script>
import ModalPromotion from '@/components/ModalPromotion.vue';
import { PROMOTIONS_TABLE_FIELDS } from '../enums/promotions';

export default {
	name: 'SearchWeightPromotionForm',
	components: {
		ModalPromotion,
	},
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		invalidFeedback: {
			type: String,
			default: null,
		},
		isValid: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			localList: this.list,
		};
	},
	computed: {
		hasListItem() {
			return this.list && this.list.length > 0;
		},
		promotionsTableFields() {
			const pickedKeys = ['id', 'title', 'type'];
			return PROMOTIONS_TABLE_FIELDS.filter((item) => pickedKeys.includes(item.key));
		},
	},
	methods: {
		handleListChange(list) {
			this.$emit('onChange', list);
		},
	},
};
</script>

<style lang="scss" scoped>
	.btn-add {
		min-width: rem(80);
	}

	.promotion-box {
		&.is-invalid {
			border: 1px solid $color-alert;
			border-radius: rem(4);
		}

		&-list {
			// rem(16) + border 1 px
			padding: 0 rem(17);
		}

		// .promotion-box-id
		&-id {
			width: rem(32);
		}

		// .promotion-box-title
		&-title {
			flex: 3;
		}

		// .promotion-box-type
		&-type {
			flex: 1;
		}

		// .promotion-box-data
		&-data {
			font-size: rem($font-size-label);
			margin-bottom: rem(16);

			&:last-child {
				margin-bottom: 0;
			}

			.caption {
				font-size: rem($font-size-caption);
				font-weight: $font-weight-bold;
				color: $color-black-45;
			}
		}
	}

	.promotion-list {
		overflow-y: auto;
		min-height: rem(60);
		max-height: rem(468);
		padding: rem(20) rem(16);
		border-radius: rem(4);
		border: solid 1px $color-gray-400;
		list-style: none;

		.list-item {
			border-radius: rem(4);
			background-color: $color-gray-300;
			color: $color-black-90;
			display: inline-block;
			padding: 0 rem(6);
			margin-right: rem(12);
			margin-bottom: rem(12);
		}
	}
</style>
